/* ============================================
   NAOKO — USP bar (auto-przechodząca karuzela na mobile)
   File: assets/naoko-usp-bar.js
   ============================================ */
(function () {
  function init(root) {
    if (!root || root.dataset.uspInit === '1') return;
    var track = root.querySelector('.naoko-usp-bar__track');
    if (!track) return;
    root.dataset.uspInit = '1';

    var items = track.children;
    if (items.length < 2) return;

    var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mqMobile = window.matchMedia('(max-width: 749px)');

    var idx = 0;
    var timer = null;
    var paused = false;

    function go(i) {
      idx = (i + items.length) % items.length;
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }
    function tick() {
      if (!paused && mqMobile.matches && !document.hidden) go(idx + 1);
    }
    function start() {
      if (reduce) return;
      stop();
      timer = window.setInterval(tick, interval);
    }
    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    // synchronizuj indeks po ręcznym przewinięciu (swipe)
    var st;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(st);
        st = window.setTimeout(function () {
          if (track.clientWidth) idx = Math.round(track.scrollLeft / track.clientWidth);
        }, 120);
      },
      { passive: true }
    );

    // pauza na interakcję
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) {
      root.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) {
      root.addEventListener(ev, function () { paused = false; }, { passive: true });
    });

    start();
  }

  function initAll() {
    document.querySelectorAll('.naoko-usp-bar').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector && e.target.querySelector('.naoko-usp-bar');
    if (el) {
      el.dataset.uspInit = '';
      init(el);
    }
  });
})();
